import { Container, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'
import FeaturesCard from "../../Components/FeaturesCards";
import SectionHeading from "../../Components/SectionHeading";

import quality from "../../images/quality.png"
import tournament from "../../images/tournament.png"
import oneMatch from "../../images/oneMatch.png"
import metaverse from "../../images/metaverse.png"
import NumberCards from "../../Components/NumberCards";

const Numbers = () => {
    const [ useBets , setBets ] = useState("0") 
    const [ useMatchPlayed , setMatchPlayed ] = useState("0") 
    const [ useHoursPlayed , setHoursPlayed ] = useState("0") 
    // const [ useBets , setBets ] = useState("0") 
    useEffect(() =>{
        AOS.init({duration: 2000})

        fetch('https://metasnooker.herokuapp.com/api/auth/count', {
            method: "GET",
        }).then(jsonData => {
            jsonData.json().then(data => {
                setMatchPlayed(data.numberOfBets)
                setBets(data.numberOfBets)
            })
        });
        fetch('https://metasnooker.herokuapp.com/api/auth/countHours', {
            method: "GET",
        }).then(jsonData => {
            jsonData.json().then(data => {
                console.log("Data2: ",data.TotalHours)
                setHoursPlayed(data.TotalHours)
            })
        });
    },[])
    return(
        <div className="mt-5 py-5">
            <Container>
                <Grid
                    container
                    justifyContent="flex-start"
                    alignContent="center"
                >
                    <Grid
                        xs={12}
                        className="align-self-center"
                        data-aos="fade-up"
                    >
                        <SectionHeading
                            subHeading = "Game Stats"
                            heading = "The numbers don't lie" 
                            customClass = " mx-auto text-center"
                        />
                    </Grid>
                    <Grid
                        container
                        xs={12}
                        className="text-center align-self-center"
                    >
                        <NumberCards 
                            // number = "7,300+"
                            number = "34,282,410"
                            title = "Token Burned"
                            customClass="MS---Number_card1"
                            cardAnimate = "zoom-in"
                        />
                        <NumberCards 
                            // number = "420"
                            number = {useMatchPlayed}
                            title = "Total Matched Played"
                            customClass="MS---Number_card1"
                            cardAnimate = "zoom-in"
                        />
                        <NumberCards 
                            // number = "150hrs"
                            number = {useHoursPlayed}
                            title = "Total Hours Played"
                            customClass="MS---Number_card1"
                            cardAnimate = "zoom-in"
                        />
                        <NumberCards 
                            // number = "150kMSF"
                            number = {useBets}
                            title = "Total Bets"
                            customClass="MS---Number_card1"
                            cardAnimate = "zoom-in"
                        />
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}
export default Numbers;